import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { GoPlus } from "react-icons/go";
import AdminSubjectList from "./AdminSubjectList";
import AdminSubjectForm from "./AdminSubjectForm";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "styles/admin.css";

const AdminSubject = () => {
  const [subjects, setSubjects] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editSubject, setEditSubject] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const fetchSubjects = async (query = "") => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const response = await fetch(
        "https://algoritm-api-edu.uz/api/admin/Subjects/GetList",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            page: 1,
            pageSize: 100,
            search: query.trim(),
          }),
        }
      );

      if (!response.ok) throw new Error("Server xato");

      const data = await response.json();
      setSubjects(data.rows || data || []);
      console.log("Fetched subjects:", data);
      
    } catch (err) {
      console.error("Xato:", err);
      setSubjects([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSubjects();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => fetchSubjects(searchQuery), 400);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  const handleCreate = () => {
    setEditSubject(null);
    setShowForm(true);
  };

  const handleEdit = (subject) => {
    setEditSubject(subject);
    setShowForm(true);
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditSubject(null);
    fetchSubjects(searchQuery);
  };

  return (
    <div className="admin-subject">
      <AnimatePresence mode="wait">
        {!showForm ? (
          <motion.div
            key="list"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
          >
            <div className="subjects-header">
              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="text"
                  placeholder="Fan nomi bo'yicha"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="subject-add"
                onClick={handleCreate}
              >
                <GoPlus size={20} />
                Fan yaratish
              </motion.button>
            </div>

            <div style={{ minHeight: "60vh", position: "relative" }}>
              <AnimatePresence mode="wait">
                {isLoading ? (
                  <motion.div
                    key="loading"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.8 }}
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                    }}
                  >
                    <motion.div
                      animate={{ rotate: 360 }}
                      transition={{
                        duration: 1.2,
                        repeat: Infinity,
                        ease: "linear",
                      }}
                      style={{
                        width: 64,
                        height: 64,
                        border: "6px solid #e0e7ff",
                        borderTop: "6px solid #28a745",
                        borderRadius: "50%",
                        margin: "0 auto 16px",
                      }}
                    />
                    <p
                      style={{
                        color: "#38e360",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                    >
                      Yuklanmoqda...
                    </p>
                  </motion.div>
                ) : subjects.length === 0 ? (
                  <motion.div
                    key="empty"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    style={{
                      position: "absolute",
                      top: "30%",
                      left: "40%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                      color: "#94a3b8",
                    }}
                  >
                    <div
                      style={{
                        width: 80,
                        height: 80,
                        background: "#f1f5f9",
                        borderRadius: "50%",
                        margin: "0 auto 20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "36px",
                      }}
                    ></div>
                    <h3 style={{ fontSize: "20px", margin: "0 0 8px" }}>
                      {searchQuery
                        ? "Hech narsa topilmadi"
                        : "Hozircha fanlar yo‘q"}
                    </h3>
                    <p style={{ fontSize: "15px", color: "#64748b" }}>
                      {searchQuery
                        ? "Boshqa so‘z bilan qidirib ko‘ring"
                        : "Yangi fan qo‘shishni boshlang"}
                    </p>
                  </motion.div>
                ) : (
                  <motion.div
                    key="list-content"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                  >
                    <AdminSubjectList
                      subjects={subjects}
                      onEdit={handleEdit}
                      fetchSubjects={() => fetchSubjects(searchQuery)}
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </motion.div>
        ) : (
          <motion.div
            key="form"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <AdminSubjectForm
              onClose={handleFormClose}
              subject={editSubject}
              fetchSubjects={() => fetchSubjects(searchQuery)}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <ToastContainer position="top-right" autoClose={3000} theme="light" />
    </div>
  );
};

export default AdminSubject;
